/**
 * Environment configuration for the frontend application.
 *
 * Bun's static bundler inlines process.env.BUN_PUBLIC_* at bundle time.
 * This works for both:
 * - Development: bun --hot (reads from .env)
 * - Production: bun build (inlines at build time)
 */

export const config = {
  apiUrl: process.env.BUN_PUBLIC_API_URL ?? "",
  clerkPublishableKey: process.env.BUN_PUBLIC_CLERK_PUBLISHABLE_KEY ?? "",
  smallPriceId: process.env.BUN_PUBLIC_STRIPE_SMALL_PRICE_ID,
  mediumPriceId: process.env.BUN_PUBLIC_STRIPE_MEDIUM_PRICE_ID,
  largePriceId: process.env.BUN_PUBLIC_STRIPE_LARGE_PRICE_ID,
};

